module.exports = __webpack_public_path__ + "static/fabric-shimmer-styles-custom-5cdb5db5e6084fb6e83df38633301fa7.gif";